import React from 'react';

type LocationValues = {
  primaryCountries: [string, string][];
  secondaryCountries: [string, string][];
  allCountries: [string, string][];
};

const createLocationValues = (): LocationValues => ({
  primaryCountries: [],
  secondaryCountries: [],
  allCountries: [],
});

const primaryCodes: string[] = ['BY', 'RU', 'UA', 'KZ'];

export const useCountriesValues = (): LocationValues => {
  const [values, setValues] = React.useState<LocationValues>(
    createLocationValues()
  );

  React.useEffect(() => {
    Promise.all([
      import('i18n-iso-countries'),
      import('i18n-iso-countries/langs/ru.json'),
    ]).then(([countries, localeData]) => {
      countries.registerLocale(localeData);

      const names = countries.getNames('ru', { select: 'official' });

      const nextValues = Object.entries(names).reduce((acc, pair) => {
        const [code] = pair;

        if (primaryCodes.includes(code)) {
          acc.primaryCountries.push(pair);
        } else {
          acc.secondaryCountries.push(pair);
        }

        acc.allCountries.push(pair);

        return acc;
      }, createLocationValues());

      nextValues.primaryCountries.sort(([code1], [code2]) => {
        return primaryCodes.indexOf(code1) - primaryCodes.indexOf(code2);
      });

      setValues(nextValues);
    });
  }, []);

  return values;
};
